export interface GetCurExternalContactGateInput {
  isWeComBrowser: boolean;
  authenticated: boolean;
  jssdkReady: boolean;
  mockMode: boolean;
}

export function canCallGetCurExternalContact(input: GetCurExternalContactGateInput): boolean {
  return input.isWeComBrowser && input.authenticated && (input.jssdkReady || input.mockMode);
}
